/**
 * Shared page header — large title + supporting description.
 * Used across all internal app pages for consistency.
 */
export function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testId}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-xs font-medium text-[#3B82F6] mb-2">{eyebrow}</p>
        )}
        <h1 className="font-['Geist'] font-semibold text-2xl sm:text-[28px] tracking-tight text-[#0F172A] leading-tight">
          {title}
        </h1>
        {description && (
          <p className="mt-1.5 text-sm text-[#64748B] leading-relaxed max-w-2xl">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
